import OPERATORS from '@tekion/tekion-base/constants/filterOperators';
export var CONTAINS = {
  id: OPERATORS.CONTAINS,
  name: __('Contains')
};
export var NOT_CONTAINS = {
  id: OPERATORS.NOT_CONTAINS,
  name: __('Does Not Contain')
};
export var EQUALS = {
  id: OPERATORS.IN,
  name: __('Equals')
};
export var NOT_EQUALS = {
  id: OPERATORS.NIN,
  name: __('Not Equals')
};
export var GREATER_THAN = {
  id: OPERATORS.GT,
  name: __('Greater Than')
};
export var GREATER_THAN_EQUAL = {
  id: OPERATORS.GTE,
  name: __('Greater Than Equal')
};
export var LESS_THAN = {
  id: OPERATORS.LT,
  name: __('Less Than')
};
export var LESS_THAN_EQUAL = {
  id: OPERATORS.LTE,
  name: __('Less Than Equal')
};
export var BETWEEN = {
  id: 'BETWEEN',
  name: __('Between')
};
// For between as accepted by backend
export var BTW = {
  id: OPERATORS.BTW,
  name: __('Between')
};
export var IN = {
  id: OPERATORS.IN,
  name: __('In')
};
export var NOT_IN = {
  id: OPERATORS.NIN,
  name: __('Not In')
};
export var BTW_INCLUSIVE = {
  id: OPERATORS.BTW_INCLUSIVE,
  name: __('Between')
};
export var EXISTS = {
  id: OPERATORS.EXISTS,
  name: __('Exists')
};
export var NOT_EXISTS = {
  id: OPERATORS.NOT_EXISTS,
  name: __('Doesn\'t Exist')
};
export var SCRIPT = {
  id: OPERATORS.SCRIPT,
  name: __('In')
};